import { useCurrentTracking } from './use-current-tracking';
export function useTrackingOccurence() {
  var _useCurrentTracking;

  return (_useCurrentTracking = useCurrentTracking()) === null || _useCurrentTracking === void 0 ? void 0 : _useCurrentTracking.occurrence;
}